/**
 * @module ScrollToTop
 */
;(function ScrollToTop() {
    function scrollToTop(dom) {
        /**
         * // local object availability
         * @type {scrollToTop}
         * @private
         */
        var _this = this

        /**
         * @type {int}
         * @private
         */
        this.offSetTop = 800

        /**
         * @method cacheDom
         *  assign {jQuery|HTMLElement(s)} to object
         */
        this.cacheDom = function () {
            this.$window = $(window)
        }

        /**
         * @method bindEvents
         * @returns {undefined}
         */
        this.bindEvents = function () {
            _this.$window.scroll(function () {
                if (_this.$window.scrollTop() > _this.offSetTop) {
                    dom.fadeIn()
                } else {
                    dom.fadeOut()
                }
            })

            dom.on('click', function () {
                $('html, body').animate({ scrollTop: 0 }, 800)
                return false
            })
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.cacheDom()
            _this.bindEvents()
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.scrollToTop = scrollToTop
})()

$(document).ready(function () {
    var $scrollToTopButton = $("[data='scroll-to-top']")
    if ($scrollToTopButton.length) {
        new window.Creaton.scrollToTop($scrollToTopButton)
    }
})
